/**
 * Cross-Sell Carousel
 * ====================
 * + Converge tracking: Cross Sell Added To Cart + cookie map
 */

(function () {
  'use strict';

  function addToCart(variantId, quantity, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: parseInt(variantId, 10),
          quantity: quantity || 1,
          properties: properties || {}
        }]
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed to add to cart');
      return res.json();
    });
  }

  function handleVariantChange(select) {
    var card = select.closest('.cs-carousel__card');
    if (!card) return;

    var selectedOption = select.options[select.selectedIndex];
    var newVariantId = selectedOption.value;
    var newPrice = selectedOption.getAttribute('data-price');

    var addBtn = card.querySelector('[data-cs-carousel-add]');
    if (addBtn) {
      addBtn.setAttribute('data-variant-id', newVariantId);
    }

    card.setAttribute('data-variant-id', newVariantId);

    var carouselPrice = parseFloat(card.getAttribute('data-carousel-price') || 0);
    var newPriceCents = parseInt(newPrice, 10);
    var carouselPriceCents = Math.round(carouselPrice * 100);

    var pricingEl = card.querySelector('.cs-carousel__pricing');
    if (!pricingEl) return;

    if (carouselPrice > 0 && carouselPriceCents < newPriceCents) {
      var savingsPct = Math.round((newPriceCents - carouselPriceCents) / newPriceCents * 100);
      pricingEl.innerHTML =
        '<span class="cs-carousel__price-original">' + formatMoney(newPriceCents) + '</span>' +
        '<span class="cs-carousel__price-sale">' + formatMoney(carouselPriceCents) + '</span>';
    } else {
      pricingEl.innerHTML =
        '<span class="cs-carousel__price">' + formatMoney(newPriceCents) + '</span>';
    }
  }

  function formatMoney(cents) {
    var sample = document.querySelector('.cs-carousel__price, .cs-carousel__price-sale, .cs-carousel__price-original');
    var useComma = sample && sample.textContent.indexOf(',') > -1;
    var amount = (cents / 100).toFixed(2);
    if (useComma) amount = amount.replace('.', ',');
    var symbol = '€';
    var moneyEl = document.querySelector('.cs-carousel__price-sale, .cs-carousel__price');
    if (moneyEl) {
      var match = moneyEl.textContent.match(/^[^0-9,.\s]+/);
      if (match) symbol = match[0];
    }
    return symbol + amount;
  }

  function handleCarouselAdd(btn) {
    if (btn.classList.contains('cs-carousel__add-btn--loading')) return;

    var variantId = btn.getAttribute('data-variant-id');
    var carouselPrice = btn.getAttribute('data-carousel-price') || '0';

    if (!variantId) return;

    btn.classList.add('cs-carousel__add-btn--loading');
    var originalText = btn.textContent;
    btn.textContent = '...';

    // Get product name from card
    var card = btn.closest('.cs-carousel__card');
    var productName = card ? (card.querySelector('.cs-carousel__title') || {}).textContent || '' : '';
    var productId = card ? card.getAttribute('data-product-id') || '' : '';

    /* ── Converge: Enrich ATC + write cookie ──────────── */
    window.__cvg_atc_handled = true;
    if (typeof CvgTrack !== 'undefined') {
      CvgTrack.set({ atc_location: 'minicart_carousel_cross-sell' });
      CvgTrack.setAtcMap(parseInt(variantId, 10), 'minicart_carousel_cross-sell', null);
    }
    /* ── End Converge ──────────────────────────────────── */

    addToCart(variantId, 1, {
      '_cross_sell': 'true',
      '_cross_sell_price': String(carouselPrice)
    })
      .then(function () {
        btn.classList.remove('cs-carousel__add-btn--loading');
        btn.classList.add('cs-carousel__add-btn--added');
        btn.textContent = '✓';

        /* ── Converge: Track Cross Sell Added To Cart ────── */
        if (typeof CvgTrack !== 'undefined') {
          CvgTrack.track('Added To Cart (Cross Sell)', {
            product_id: String(productId),
            variant_id: String(variantId),
            name: productName.trim(),
            price: carouselPrice ? parseFloat(carouselPrice) : 0,
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
            quantity: 1,
            atc_location: 'minicart_carousel_cross-sell'
          });
        }
        /* ── End Converge ────────────────────────────────── */

        updateCartCount();

        setTimeout(function () {
          if (card) {
            card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
            card.style.opacity = '0';
            card.style.transform = 'scale(0.92)';
            setTimeout(function () {
              card.remove();
              checkCarouselEmpty();
              refreshCartDrawer();
            }, 300);
          }
        }, 800);
      })
      .catch(function (err) {
        console.error('Carousel add failed:', err);
        btn.classList.remove('cs-carousel__add-btn--loading');
        btn.textContent = originalText;
      });
  }

  function checkCarouselEmpty() {
    var carousel = document.getElementById('cs-carousel');
    if (!carousel) return;
    var remaining = carousel.querySelectorAll('.cs-carousel__card');
    if (remaining.length === 0) {
      carousel.style.transition = 'opacity 0.3s ease';
      carousel.style.opacity = '0';
      setTimeout(function () { carousel.remove(); }, 300);
    }
  }

  function handleNav(direction) {
    var track = document.getElementById('cs-carousel-track');
    if (!track) return;
    var card = track.querySelector('.cs-carousel__card');
    var cardWidth = card ? card.offsetWidth + 10 : 160;
    track.scrollBy({ left: direction === 'next' ? cardWidth : -cardWidth, behavior: 'smooth' });
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll(
          '.cart-count, [data-cart-count], .cart-count-bubble span, .header__cart-count, .cart-bubble__text-count'
        ).forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }

  function refreshCartDrawer() {
    setTimeout(function () {
      var cartItemsComponent = document.querySelector('cart-items-component');
      var sectionId = cartItemsComponent
        ? (cartItemsComponent.getAttribute('data-section-id') || 'header')
        : 'header';

      fetch('/?sections=' + sectionId, { cache: 'no-store' })
        .then(function (res) { return res.json(); })
        .then(function (sections) {
          var html = sections[sectionId];
          if (!html) return;
          var tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          var newItems = tempDiv.querySelector('cart-items-component');
          var curItems = document.querySelector('cart-items-component');
          if (newItems && curItems) curItems.innerHTML = newItems.innerHTML;
          var newBubbles = tempDiv.querySelectorAll('.cart-bubble__text-count');
          var curBubbles = document.querySelectorAll('.cart-bubble__text-count');
          if (newBubbles.length && curBubbles.length) {
            curBubbles.forEach(function (b) { b.textContent = newBubbles[0].textContent.trim(); });
          }
          var newIcon = tempDiv.querySelector('cart-icon');
          var curIcon = document.querySelector('cart-icon');
          if (newIcon && curIcon) {
            curIcon.className = newIcon.className;
            curIcon.innerHTML = newIcon.innerHTML;
          }
        })
        .catch(function (err) { console.error('Carousel drawer refresh error:', err); });
    }, 500);
  }

  function init() {
    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-cs-carousel-add]');
      if (addBtn) { handleCarouselAdd(addBtn); return; }
      if (e.target.closest('#cs-carousel-prev')) { handleNav('prev'); return; }
      if (e.target.closest('#cs-carousel-next')) { handleNav('next'); return; }
    });

    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-variant-select]')) {
        handleVariantChange(e.target);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
